<template lang="pug">
  .modal.is-active(:class="{'modal-sidebar-desktop-open': showSidebarDesktop }")
    .modal-background(@click="emitClose")
    .card.margin-5em-sides
      header.card-header
        p.card-header-title
          span Errores encontrados
        a.card-header-icon
          span.icon
            button.delete(@click="emitClose")
      .card-content
        .content
          ul
            li.tal(v-for="(error, index) in errores" :key="index")
              span {{ error }}
</template>

<script>

export default {
  name: 'contratos-carga-manual',
  props: ['errores'],
  methods: {
    emitClose () {
      this.$emit('close')
    }
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  }
}
</script>
<style lang="stylus" scoped>
  .tal
    text-align: left
  .margin-5em-sides
    margin 0px 5em
</style>



// WEBPACK FOOTER //
// Component_Errores_Multiples.vue?cf518b6a